"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFooter = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _core = require("@material-ui/core");

var _validations = require("egov-ui-kit/utils/validations");

var _Screen = require("egov-ui-kit/common/common/Screen");

var _Screen2 = _interopRequireDefault(_Screen);

var _api = require("egov-ui-kit/utils/api");

var _components = require("egov-ui-kit/components");

var _PTServiceUrls = require("egov-ui-kit/common/PTServiceUrls");

var _commons = require("egov-ui-kit/utils/commons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Custom table footer component
var CustomFooter = exports.CustomFooter = function (_Component) {
  (0, _inherits3.default)(CustomFooter, _Component);

  function CustomFooter() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CustomFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomFooter.__proto__ || Object.getPrototypeOf(CustomFooter)).call.apply(_ref, [this].concat(args))), _this), _this.handlePageChange = function (_, page) {
      return _this.props.changePage(page);
    }, _this.handleRowChange = function (event) {
      return _this.props.changeRowsPerPage(event.target.value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CustomFooter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          count = _props.count,
          rowsPerPage = _props.rowsPerPage,
          page = _props.page,
          noOfRowSelected = _props.noOfRowSelected,
          totalSuspenseBalance = _props.totalSuspenseBalance,
          netPayableAmount = _props.netPayableAmount,
          redirectPay = _props.redirectPay,
          toalOnlineDiscount = _props.toalOnlineDiscount;


      return _react2.default.createElement(
        _core.TableFooter,
        null,
        _react2.default.createElement(
          _core.TableRow,
          null,
          _react2.default.createElement(
            _core.TableCell,
            { style: { display: "flex" }, colSpan: 1000 },
            _react2.default.createElement(
              _core.Grid,
              { container: true, spacing: 3, className: "mt-3" },
              _react2.default.createElement(
                _core.Grid,
                { item: true, xs: 6 },
                _react2.default.createElement(
                  _core.Grid,
                  { container: true, spacing: 3, className: "flex-column" },
                  _react2.default.createElement(
                    _core.Grid,
                    { item: true, xs: 4 },
                    _react2.default.createElement(
                      "p",
                      { className: "mb-0", style: (0, _extends3.default)({}, _commons.styles.headerDesignFooter, { width: "40rem" }) },
                      "No of Record Selected : ",
                      _react2.default.createElement(
                        "span",
                        { style: _commons.styles.spanDesign },
                        noOfRowSelected
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _core.Grid,
                    { item: true, xs: 4 },
                    _react2.default.createElement(
                      "p",
                      { className: "mb-0", style: (0, _extends3.default)({}, _commons.styles.headerDesignFooter, { width: "40rem" }) },
                      "Net Payable Amount : ",
                      _react2.default.createElement(
                        "span",
                        { style: _commons.styles.spanDesign },
                        netPayableAmount
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _core.Grid,
                    { item: true, xs: 4 },
                    _react2.default.createElement(
                      "p",
                      { className: "mb-0", style: (0, _extends3.default)({}, _commons.styles.headerDesignFooter, { width: "40rem" }) },
                      "Total Online Discount : ",
                      _react2.default.createElement(
                        "span",
                        { style: _commons.styles.spanDesign },
                        toalOnlineDiscount
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _core.Grid,
                { item: true, xs: 2 },
                _react2.default.createElement(
                  "button",
                  {
                    style: {
                      width: "110px",
                      padding: "10px 15px",
                      background: "coral",
                      color: "azure",
                      border: "0px",
                      borderRadius: "4px"
                    },
                    onClick: function onClick(e) {
                      return redirectPay(e, netPayableAmount);
                    }
                  },
                  "Pay : ",
                  netPayableAmount
                )
              ),
              _react2.default.createElement(
                _core.Grid,
                { item: true, xs: 4 },
                _react2.default.createElement(_core.TablePagination, {
                  component: "div",
                  count: count,
                  rowsPerPage: rowsPerPage,
                  page: page,
                  labelRowsPerPage: 5,
                  rowsPerPageOptions: [5, 20, 100],
                  onChangePage: this.handlePageChange,
                  onChangeRowsPerPage: this.handleRowChange
                })
              )
            )
          )
        )
      );
    }
  }]);
  return CustomFooter;
}(_react.Component);

var CurrentDemand = function (_Component2) {
  (0, _inherits3.default)(CurrentDemand, _Component2);

  function CurrentDemand(props) {
    var _this3 = this;

    (0, _classCallCheck3.default)(this, CurrentDemand);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (CurrentDemand.__proto__ || Object.getPrototypeOf(CurrentDemand)).call(this, props));

    _this2.column = [{
      name: "payableAmt",
      label: "Payable Amount",
      options: { display: false }
    }, {
      name: "billType",
      label: "Bill Type",
      options: { display: false }
    }, {
      name: "shareType",
      label: "Share Type",
      options: { display: false }
    }, {
      name: "fromQtr",
      label: "From Qtr",
      options: { display: false }
    }, {
      name: "toQtr",
      label: "To QTR",
      options: { display: false }
    }, {
      name: "allBillType",
      label: "All Bill Type",
      options: { display: false }
    }, {
      name: "fromQtr",
      label: "Quarter Range",
      options: {
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return _react2.default.createElement(
            "div",
            null,
            tableMeta.rowData[3],
            " ",
            _react2.default.createElement(
              "span",
              null,
              "to"
            ),
            " ",
            tableMeta.rowData[4]
          );
        }
      }
    }, {
      name: "billType",
      label: "Bill/Share Type",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "12px", maxWidth: "12px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return _react2.default.createElement(
            "div",
            null,
            tableMeta.rowData[1],
            "/",
            tableMeta.rowData[2],
            " -",
            tableMeta.rowData[5]
          );
        }
      }
    }, {
      name: "presentationDate",
      label: "Presentation Date",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "22px", maxWidth: "22px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? (0, _commons.formatEpochDate)(value) : "-";
        }
      }
    }, {
      name: "rebateDate",
      label: "Rebate Date",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "22px", maxWidth: "22px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? (0, _commons.formatEpochDate)(value) : "-";
        }
      }
    }, {
      name: "outstandingDate",
      label: "Outstanding Date",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "22px", maxWidth: "22px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? (0, _commons.formatEpochDate)(value) : "-";
        }
      }
    }, {
      name: "payableAmt",
      label: "Gross",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "17px", maxWidth: "17px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? value.toString() : "-";
        }
      }
    }, {
      name: "rebateAmount",
      label: "Rebate",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "17px", maxWidth: "17px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? value.toString() : "-";
        }
      }
    }, {
      name: "interestAmount",
      label: "Interest",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "17px", maxWidth: "17px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? value.toString() : "-";
        }
      }
    }, {
      name: "penaltyAmount",
      label: "Penalty",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "17px", maxWidth: "17px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? value.toString() : "-";
        }
      }
    }, {
      name: "netAmount_After_Waive",
      label: "Net Payable",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "17px", maxWidth: "17px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? value.toString() : "-";
        }
      }
    }, {
      name: "netAmount",
      label: "Net",
      options: {
        setCellProps: function setCellProps() {
          return {
            style: { minWidth: "17px", maxWidth: "17px", textAlign: "left" }
          };
        },
        customBodyRender: function customBodyRender(value) {
          return value ? value.toString() : "-";
        }
      }
    }];

    _this2.onSearchHandler = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var assesseeNo, statusOfInputField, re, requiredObject, response, responseData, demandList, asseseeDetails;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                assesseeNo = _this2.state.assesseeNo;
                statusOfInputField = assesseeNo == "";

                _this2.setState({
                  showTable: false,
                  demandList: [],
                  rowsSelected: [],
                  arraydemand: [],
                  noOfRowSelected: 0,
                  netPayableAmount: 0,
                  totalSuspenseBalance: 0,
                  toalOnlineDiscount: 0,
                  streetName: "",
                  wardno: "",
                  premisesNo: ""
                });

                if (!statusOfInputField) {
                  _context.next = 8;
                  break;
                }

                (0, _commons.showToast)("No search criteria given!", "warning");
                _context.next = 26;
                break;

              case 8:
                re = /^\d{12}$/;

                if (!re.test(assesseeNo)) {
                  _context.next = 25;
                  break;
                }

                _context.prev = 10;

                _this2.setState({ loadingStatus: true });
                requiredObject = { RequestData: { asseseeNo: assesseeNo } };
                // prettier-ignore

                _context.next = 15;
                return (0, _api.httpRequestForPT)(_PTServiceUrls.urlCalculateAllBillPayment, "", [], requiredObject);

              case 15:
                response = _context.sent;

                //   {"RequestInfo":{"apiId":"Rainmaker","ver":".01","ts":"","action":"","did":"1","key":"","msgId":"20170310130900|en_IN","authToken":"3c689e45-e4bf-402f-bf89-7438e2b410bf"},"RequestData":{"asseseeNo":"110010100379"}}
                if (response.tokenStatus == "invalid") {
                  _this2.setState({ loadingStatus: false });
                  (0, _commons.showToast)("Invalid Access Token. Please login again", "error");
                } else if (response.tokenStatus == "valid" && (response.status == 200 || response.status == 201)) {
                  responseData = response.data.ResponseData;
                  demandList = responseData.demandList && responseData.demandList.length > 0 ? responseData.demandList : [];
                  asseseeDetails = responseData && Object.keys(responseData.asseseeDetails).length > 0 ? responseData.asseseeDetails : {};

                  // current demand all bill
                  // netAmount_after_waiver = netAmount - extra_rebate_amount
                  // rebateAmount = rebateAmount + extra_rebate_amount

                  demandList.forEach(function (item) {
                    item.netAmountAfterWaiver = item.netAmount - item.extraRebateAmount;
                    item.rebateAmountCal = item.rebateAmount + item.extraRebateAmount;
                  });

                  setTimeout(function () {
                    _this2.setState({
                      demandList: demandList,
                      showTable: true,
                      asseseeDetails: asseseeDetails,
                      loadingStatus: false
                    });
                  }, 500);
                } else if (response && response.data.hasOwnProperty("Errors") && response.data.Errors.length > 0) {
                  _this2.setState({ loadingStatus: false });
                  (0, _commons.showToast)(response.data.Errors[0].message, "error");
                } else {
                  (0, _commons.showToast)("Something went wrong!", "warning");
                  _this2.setState({ loadingStatus: false });
                }
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](10);

                _this2.setState({ loadingStatus: false });
                (0, _commons.showToast)(_context.t0.message, "warning");

              case 23:
                _context.next = 26;
                break;

              case 25:
                (0, _commons.showToast)("Please input valid assessee No ", "warning");

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[10, 19]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this2.onResetHandler = function (e) {
      e.preventDefault();
      _this2.setState({
        assesseeDetails: {},
        assesseeNo: "",
        premiseNo: "",
        showTable: false,
        streetName: "",
        premisesNo: "",
        wardno: "",
        demandList: [],
        rowsPerPage: 10,
        page: 0,
        rowsSelected: [],
        noOfRowSelected: 0,
        netPayableAmount: 0,
        totalSuspenseBalance: 0,
        toalOnlineDiscount: 0,
        arraydemand: [],
        showModal: false
      });
    };

    _this2.findIndexesByObjectComparison = function (array1, array2) {
      var indexes = [];
      array1.forEach(function (item1, index1) {
        if (array2.some(function (item2) {
          return item1.allBillType === item2.allBillType && item1.effectiveStorage === item2.effectiveStorage && item1.freshBillNo === item2.freshBillNo;
        })) {
          indexes.push(index1);
        }
      });
      return indexes;
    };

    _this2.onRowSelectHandler = function (selectedRow, allRows) {
      var arraydemandState = [],
          rowsSelectedState = [],
          _this2$state = _this2.state,
          demandList = _this2$state.demandList,
          rowsSelected = _this2$state.rowsSelected,
          arraydemand = _this2$state.arraydemand,
          assesseeDetails = _this2$state.assesseeDetails,
          selectedRowIndex = selectedRow.length > 0 ? selectedRow[0].dataIndex : 0;


      if (allRows.length > 0) {
        var demandSelected = demandList[selectedRowIndex];
        var billType = demandSelected.allBillType;
        // If all rows are selected, set the entire demandList as selected
        if (allRows.length === demandList.length) {
          arraydemandState = [].concat((0, _toConsumableArray3.default)(demandList));
          rowsSelectedState = Array.from(Array(allRows.length).keys());
        }
        // if one or many row selected
        else {
            if (billType == "PD") {
              var pdBillArray = [],
                  selectedIndexesArray = [],
                  ohterBillTypesArray = [];
              if (!rowsSelected.includes(selectedRowIndex)) {
                demandList.forEach(function (obj, index) {
                  return obj.allBillType === "PD" && obj.effectiveStorage <= demandSelected.effectiveStorage && selectedIndexesArray.push(index) && pdBillArray.push(obj);
                });
                if (selectedIndexesArray.length == 0) {
                  selectedIndexesArray.push(selectedRowIndex);
                  pdBillArray.push(demandSelected);
                }
              }
              // check if the selected row index is already selected then simply remove from the list
              else if (rowsSelected.includes(selectedRowIndex)) {
                  demandList.map(function (item, index) {
                    rowsSelected.includes(index) ? item.netAmount_After_Waive = Math.round(item.payableAmt - item.rebateAmount - item.interestAmount + item.penaltyAmount) : Math.round(item.netAmount_After_Waive);
                  });
                  demandList.forEach(function (obj, index) {
                    return obj.allBillType === "PD" && obj.effectiveStorage < demandSelected.effectiveStorage && selectedIndexesArray.push(index) && pdBillArray.push(obj);
                  });
                }

              // check for other bills
              arraydemand.forEach(function (obj) {
                return obj.allBillType !== "PD" && ohterBillTypesArray.push(obj);
              });
              var indexes = _this2.findIndexesByObjectComparison(demandList, ohterBillTypesArray);
              // finally push all the objects into an single array
              arraydemandState = [].concat(pdBillArray, ohterBillTypesArray);
              rowsSelectedState = [].concat(selectedIndexesArray, (0, _toConsumableArray3.default)(indexes));
            } else if (billType == "LOI") {
              var loiBillArray = [],
                  _selectedIndexesArray = [],
                  _ohterBillTypesArray = [];
              if (!rowsSelected.includes(selectedRowIndex)) {
                demandList.forEach(function (obj, index) {
                  return obj.allBillType === "LOI" && _selectedIndexesArray.push(index) && loiBillArray.push(obj);
                });
                if (_selectedIndexesArray.length == 0) {
                  _selectedIndexesArray.push(selectedRowIndex);
                  loiBillArray.push(demandSelected);
                }
              }
              // check for other bills
              arraydemand.forEach(function (obj) {
                return obj.allBillType !== "LOI" && _ohterBillTypesArray.push(obj);
              });
              var _indexes = _this2.findIndexesByObjectComparison(demandList, _ohterBillTypesArray);
              // finally push all the objects into an single array
              arraydemandState = [].concat(loiBillArray, _ohterBillTypesArray);
              rowsSelectedState = [].concat(_selectedIndexesArray, (0, _toConsumableArray3.default)(_indexes));
            } else if (billType == "FS") {
              var fsBillArray = [],
                  _selectedIndexesArray2 = [],
                  _ohterBillTypesArray2 = [];
              if (!rowsSelected.includes(selectedRowIndex)) {
                demandList.forEach(function (obj, index) {
                  if (obj.allBillType === "FS" && obj.rebateDate <= demandSelected.rebateDate) {
                    _selectedIndexesArray2.push(index);
                    fsBillArray.push(obj);
                  }
                });
                if (_selectedIndexesArray2.length == 0) {
                  _selectedIndexesArray2.push(selectedRowIndex);
                  fsBillArray.push(demandSelected);
                }
              } else if (rowsSelected.includes(selectedRowIndex)) {
                demandList.forEach(function (obj, index) {
                  // Check if the bill type is FS
                  if (obj.allBillType === "FS") {
                    // Allow lower rebate dates
                    if (obj.rebateDate < demandSelected.rebateDate) {
                      _selectedIndexesArray2.push(index);
                      fsBillArray.push(obj);
                    }

                    // Handle only the unchecked row with the same rebateDate
                    if (obj.rebateDate === demandSelected.rebateDate && obj.freshBillNo !== demandSelected.freshBillNo && rowsSelected.includes(index)) {
                      // Uncheck or delete only this specific element
                      _selectedIndexesArray2.push(index);
                      fsBillArray.push(obj);
                    }

                    // Disallow rows with larger rebate dates
                    if (obj.rebateDate > demandSelected.rebateDate) {
                      // Do nothing for larger dates, keep them intact
                      return;
                    }
                  }
                });
              }
              // check for other bills
              arraydemand.forEach(function (obj) {
                return obj.allBillType !== "FS" && _ohterBillTypesArray2.push(obj);
              });
              var _indexes2 = _this2.findIndexesByObjectComparison(demandList, _ohterBillTypesArray2);
              // finally push all the objects into an single array
              arraydemandState = [].concat(fsBillArray, _ohterBillTypesArray2);
              rowsSelectedState = [].concat(_selectedIndexesArray2, (0, _toConsumableArray3.default)(_indexes2));
            }
          }
      }

      if (arraydemandState.length > 0) {
        // get the total net payable amount & suspend amount.
        // If there is all the PD bills seceted, subsctract the total rebate amount from the net amount, i.e for 4th, 3rd and 2nd qtr
        // Extra 5 % rebet start
        var pdBillCount = 0,
            netPayable = 0,
            totalDiscount = 0,
            maxDiscount = 200;

        arraydemandState.filter(function (demand) {
          return demand.allBillType === "PD" && pdBillCount++;
        });

        if (pdBillCount === 4) {
          arraydemandState.map(function (item) {
            if (item.allBillType === "PD") {
              netPayable = netPayable + (["4", "3", "2"].includes(item.effectiveStorage[4]) ? Math.round(item.payableAmt - item.rebateAmount - item.extraRebateAmount + item.interestAmount + item.penaltyAmount) : item.netAmount_After_Waive);
              // Payment issue fix - 01/04/25
              item.netAmount_After_Waive = Math.round(item.payableAmt - item.rebateAmount - item.extraRebateAmount + item.interestAmount + item.penaltyAmount);
            } else {
              netPayable = netPayable + Math.round(item.netAmount_After_Waive);
              // Payment issue fix - 01/04/25
              item.netAmount_After_Waive = Math.round(item.payableAmt - item.rebateAmount + item.interestAmount + item.penaltyAmount);
            }
          });
        } else {
          demandList.map(function (item, index) {
            index === selectedRowIndex ? item.netAmount_After_Waive = Math.round(item.payableAmt - item.rebateAmount + item.interestAmount + item.penaltyAmount) : Math.round(item.netAmount_After_Waive);
          });
          arraydemandState.map(function (item) {
            item.netAmount_After_Waive = Math.round(item.payableAmt - item.rebateAmount + item.interestAmount + item.penaltyAmount);
            netPayable = netPayable + item.netAmount_After_Waive;
          });
          // arraydemandState.map((item) => {
          //   netPayable = netPayable + item.netAmount_After_Waive;
          // });
        }

        // Calculate total discount and set onlineActualDiscount
        arraydemandState.forEach(function (item) {
          if (totalDiscount + item.onlineDiscount <= maxDiscount) {
            item.onlineActualDiscount = item.onlineDiscount;
          } else {
            item.onlineActualDiscount = maxDiscount - totalDiscount;
          }
          totalDiscount = totalDiscount + item.onlineActualDiscount;
        });

        var toalOnlineDiscount = 0;
        arraydemandState.map(function (item) {
          toalOnlineDiscount = toalOnlineDiscount + item.onlineActualDiscount;
        });

        // Extra 5 % rebet end
        _this2.setState({
          noOfRowSelected: arraydemandState.length,
          totalSuspenseBalance: assesseeDetails.suspenseBalance || "0",
          netPayableAmount: netPayable - totalDiscount,
          arraydemand: arraydemandState,
          rowsSelected: rowsSelectedState,
          toalOnlineDiscount: totalDiscount
        });
      } else {
        _this2.setState({
          noOfRowSelected: 0,
          totalSuspenseBalance: 0,
          netPayableAmount: 0,
          arraydemand: arraydemandState,
          rowsSelected: rowsSelectedState
        });
      }
    };

    _this2.state = {
      assesseeDetails: {},
      assesseeNo: "",
      mobileNo: "",
      premiseNo: "",
      showTable: false,
      streetName: "",
      premisesNo: "",
      wardno: "",
      demandList: [],
      rowsPerPage: 10,
      page: 0,
      rowsSelected: [],
      noOfRowSelected: 0,
      netPayableAmount: 0,
      totalSuspenseBalance: 0,
      toalOnlineDiscount: 0,
      arraydemand: [],
      showModal: false
    };
    return _this2;
  }

  // reset handler


  /*
       VIEW: Check bill type and put conditons according to that
          PD BIll  -> Filter out all the below quarters from selected quarter and automatically check those.
          LOI Bill -> Automatically selct all the demands of type LOI
          FS BIll  -> (select) Automatically selelct all those demands whose rebate date is less than selected demand
                      (Unselect) -> Automatically deselect all those demand whose rebate date is higher.
          */

  (0, _createClass3.default)(CurrentDemand, [{
    key: "render",
    value: function render() {
      var _this4 = this,
          _options;

      var _state = this.state,
          assesseeNo = _state.assesseeNo,
          mobileNo = _state.mobileNo,
          demandList = _state.demandList,
          showTable = _state.showTable,
          noOfRowSelected = _state.noOfRowSelected,
          totalSuspenseBalance = _state.totalSuspenseBalance,
          toalOnlineDiscount = _state.toalOnlineDiscount,
          netPayableAmount = _state.netPayableAmount,
          rowsSelected = _state.rowsSelected,
          loadingStatus = _state.loadingStatus,
          showModal = _state.showModal,
          arraydemand = _state.arraydemand,
          asseseeDetails = _state.asseseeDetails;


      var getValues = function getValues(name) {
        return asseseeDetails && Object.keys(asseseeDetails).length > 0 && asseseeDetails[name] ? asseseeDetails[name] : "";
      };

      var options = (_options = {
        filter: true,
        filterType: "checkbox",
        responsive: "stacked",
        rowsPerPage: 15,
        selectableRows: "multiple"
      }, (0, _defineProperty3.default)(_options, "filter", false), (0, _defineProperty3.default)(_options, "download", false), (0, _defineProperty3.default)(_options, "print", false), (0, _defineProperty3.default)(_options, "search", false), (0, _defineProperty3.default)(_options, "viewColumns", false), (0, _defineProperty3.default)(_options, "hover", true), (0, _defineProperty3.default)(_options, "fixedHeader", true), (0, _defineProperty3.default)(_options, "rowsSelected", rowsSelected), (0, _defineProperty3.default)(_options, "customFooter", function customFooter(count, page, rowsPerPage, changeRowsPerPage, changePage) {
        return _react2.default.createElement(CustomFooter, {
          count: count,
          page: page,
          rowsPerPage: rowsPerPage,
          changeRowsPerPage: changeRowsPerPage,
          changePage: changePage,
          noOfRowSelected: noOfRowSelected,
          totalSuspenseBalance: totalSuspenseBalance,
          netPayableAmount: netPayableAmount,
          toalOnlineDiscount: toalOnlineDiscount,
          props: _this4.props,
          data: arraydemand,
          assesseeNo: assesseeNo,
          redirectPay: redirectPay
        });
      }), (0, _defineProperty3.default)(_options, "onRowsSelect", function onRowsSelect(selectedRow, allRows) {
        return _this4.onRowSelectHandler(selectedRow, allRows);
      }), _options);

      // Pay button handler
      var redirectPay = function redirectPay(e, netPayableAmount) {
        e.preventDefault();
        // open the modal to select type of payment method
        if (netPayableAmount && netPayableAmount != "0") _this4.setState({ showModal: true });else (0, _commons.showToast)("Select at least one demand", "warning");
      };

      var handleClose = function handleClose() {
        return _this4.setState({ showModal: false });
      };

      var checkAmount = function checkAmount(totalAmount, customAmount, businessService) {
        if (totalAmount !== 0 && customAmount === 0) {
          return true;
        } else if (totalAmount === 0 && customAmount === 0 && (businessService === "WS" || businessService === "SW")) {
          return true;
        } else {
          return false;
        }
      };

      // on click payment option choose
      var onClickPaymentOptionChoose = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e, type) {
          var state, isAdvancePaymentAllowed, businessService, callbackUrl, callbackUrlBilldesk, _state$screenConfigur, screenConfiguration, _screenConfiguration$, preparedFinalObject, _preparedFinalObject$, ReceiptTemp, billPayload, taxAmount, amtToPay, taxAndPayments, buttonJsonpath, transactiondetails, accountNo, pageType, wardNo, isSuspensePayment, transactionDetails1, gateway, user1, requestBody, totalDiscount, goToPaymentGateway, srcQuery, searchResponse, ackUrl, successUrl, redirectionUrl;

          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  e.preventDefault();

                  if (!mobileNo) {
                    _context2.next = 87;
                    break;
                  }

                  state = _store2.default.getState();
                  // save the method into localstorage for the further reference.
                  // redirect to the payment page.

                  _store2.default.dispatch((0, _actions.prepareFinalObject)("assesseeNo", assesseeNo));
                  _store2.default.dispatch((0, _actions.prepareFinalObject)("asseseeDetails", asseseeDetails));
                  _store2.default.dispatch((0, _actions.prepareFinalObject)("asseseeDetails.mobileNo", asseseeDetails.mobileNo || ""));
                  _store2.default.dispatch((0, _actions.prepareFinalObject)("PayementData", arraydemand));
                  _store2.default.dispatch((0, _actions.prepareFinalObject)("totalAmoutPaybale", netPayableAmount));
                  _store2.default.dispatch((0, _actions.prepareFinalObject)("gateway", type));
                  _store2.default.dispatch((0, _actions.prepareFinalObject)("pageType", "currentDemand"));

                  localStorage.setItem("assesseeNo", assesseeNo);
                  localStorage.setItem("mobileNo", asseseeDetails.mobileNo || "");
                  localStorage.setItem("totalAmoutPaybale", netPayableAmount);
                  localStorage.setItem("toalOnlineDiscount", toalOnlineDiscount);
                  localStorage.setItem("currentDemandList", JSON.stringify(arraydemand));
                  sessionStorage.setItem("currentDemandList", JSON.stringify(arraydemand));
                  localStorage.setItem("gateway", type);
                  localStorage.setItem("formType", "all");
                  _this4.setState({ loadingStatus: true });
                  setTimeout(function () {
                    return _this4.setState({ loadingStatus: true });
                  }, 1000);

                  // Main service call start here
                  isAdvancePaymentAllowed = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.businessServiceInfo.isAdvanceAllowed");
                  businessService = "PT";
                  // egov-common/paymentRedirectPage

                  callbackUrl = "https://kmcdev.ddns.net/pg-service/transaction/PT/v1/_redirect?originalreturnurl=https://kmcdev.ddns.net/citizen/withoutAuth/paymentRedirectPage";
                  callbackUrlBilldesk = "https://kmcdev.ddns.net/citizen/withoutAuth/paymentRedirectPage";
                  _state$screenConfigur = state.screenConfiguration, screenConfiguration = _state$screenConfigur === undefined ? {} : _state$screenConfigur;
                  _screenConfiguration$ = screenConfiguration.preparedFinalObject, preparedFinalObject = _screenConfiguration$ === undefined ? {} : _screenConfiguration$;
                  _preparedFinalObject$ = preparedFinalObject.ReceiptTemp, ReceiptTemp = _preparedFinalObject$ === undefined ? {} : _preparedFinalObject$;
                  billPayload = ReceiptTemp[0];
                  taxAmount = netPayableAmount;
                  amtToPay = state.screenConfiguration.preparedFinalObject.AmountType === "partial_amount" ? state.screenConfiguration.preparedFinalObject.AmountPaid : taxAmount;


                  amtToPay = amtToPay ? Number(amtToPay) : taxAmount;

                  if (!(amtToPay > taxAmount && !isAdvancePaymentAllowed)) {
                    _context2.next = 34;
                    break;
                  }

                  alert("Advance Payment is not allowed");
                  return _context2.abrupt("return");

                case 34:
                  if (!checkAmount(taxAmount, 2500, businessService)) {
                    _context2.next = 37;
                    break;
                  }

                  (0, _commons.showToast)("Please enter an amount greater than zero!", "error");
                  return _context2.abrupt("return");

                case 37:
                  taxAndPayments = [];

                  taxAndPayments.push({
                    billId: (0, _get2.default)(billPayload, "Bill[0].id"),
                    amountPaid: amtToPay
                  });
                  buttonJsonpath = "components.div.children.footer.children." + ("" + (process.env.REACT_APP_NAME === "Citizen" ? "makePayment" : "makePayment"));
                  _context2.prev = 40;
                  transactiondetails = arraydemand;
                  accountNo = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "accountNo");
                  pageType = "all";
                  wardNo = asseseeDetails.wardNo || "", isSuspensePayment = false;
                  transactionDetails1 = [];

                  transactiondetails.map(function (item) {
                    if (isSuspensePayment) {
                      transactionDetails1.push({
                        wardNo: item.wardNo,
                        asseseeNo: item.assesseeNo,
                        txnAmount: Number(item.amount)
                      });
                    } else {
                      transactionDetails1.push({
                        wardNo: wardNo,
                        asseseeNo: assesseeNo,
                        billNo: item.billNo,
                        fsBillNo: item.freshBillNo,
                        billType: item.billType,
                        billQtr: item.fromQtr,
                        toQtr: item.toQtr,
                        rebateAmount: Number(item.rebateAmount),
                        interest: Number(item.interestAmount),
                        penalty: Number(item.penaltyAmount),
                        netAmount: Number(item.netAmount),
                        txnAmount: Number(item.netAmount_After_Waive) - Number(item.onlineActualDiscount),
                        billPeriodType: item.allBillType,
                        // added for disount
                        onlineDiscount: item.onlineActualDiscount
                      });
                    }
                  });

                  gateway = type;
                  user1 = { name: "Asit", mobileNumber: mobileNo, emailId: "", tenantId: "" };
                  requestBody = {
                    Transaction: {
                      txnAmount: Number(netPayableAmount),
                      module: businessService,
                      productInfo: "Common Payment",
                      gateway: gateway,
                      callbackUrl: callbackUrl,
                      redirectUrl: "",
                      user: user1,
                      txnDetailList: transactionDetails1
                    }
                  };
                  totalDiscount = Number(toalOnlineDiscount);

                  requestBody.Transaction.txnTypeId = "30";
                  requestBody.Transaction.txnTypeCode = "ASMT_ALL_TYPE_DEMAND";
                  requestBody.Transaction.isGoGreenPayment = "Y";
                  requestBody.Transaction.onlineDiscount = totalDiscount;
                  _context2.prev = 55;
                  _context2.next = 58;
                  return (0, _api.httpRequest)(_PTServiceUrls.urlCreateTransactions, "_create", [], requestBody);

                case 58:
                  goToPaymentGateway = _context2.sent;

                  localStorage.setItem("TransactionIDD", goToPaymentGateway.Transaction.txnId);
                  _store2.default.dispatch((0, _actions.prepareFinalObject)("payementTxnID", goToPaymentGateway.Transaction.txnId));

                  if (!((0, _get2.default)(goToPaymentGateway, "Transaction.txnAmount") == 0)) {
                    _context2.next = 71;
                    break;
                  }

                  srcQuery = "?tenantId=" + (0, _get2.default)(goToPaymentGateway, "Transaction.tenantId") + "&billIds=" + (0, _get2.default)(goToPaymentGateway, "Transaction.billId");
                  _context2.next = 65;
                  return (0, _api.httpRequest)(getPaymentSearchAPI(businessService) + srcQuery, "_search", [], {});

                case 65:
                  searchResponse = _context2.sent;
                  ackUrl = "/egov-common/acknowledgement?status=" + "success" + "&tenantId=" + "km.kolkata" + "&receiptNumber=" + goToPaymentGateway.Transaction.txnId + "&businessService=" + businessService;
                  successUrl = isPublicSearch() ? "/withoutAuth" + ackUrl : ackUrl;

                  _store2.default.dispatch((0, _commons.setRoute)(successUrl));
                  _context2.next = 73;
                  break;

                case 71:
                  redirectionUrl = (0, _get2.default)(goToPaymentGateway, "Transaction.redirectUrl") || (0, _get2.default)(goToPaymentGateway, "Transaction.callbackUrl");

                  window.location = redirectionUrl;
                  //   setRoute(redirectionUrl);

                case 73:
                  _context2.next = 78;
                  break;

                case 75:
                  _context2.prev = 75;
                  _context2.t0 = _context2["catch"](55);

                  console.log("😎 Error - ", _context2.t0.message);

                case 78:
                  _context2.next = 85;
                  break;

                case 80:
                  _context2.prev = 80;
                  _context2.t1 = _context2["catch"](40);

                  _store2.default.dispatch((0, _actions.handleScreenConfigurationFieldChange)("pay", buttonJsonpath, "props.disabled", true));
                  (0, _commons.showToast)(_context2.t1.message, "error");
                  _this4.setState({ loadingStatus: false });

                case 85:
                  _context2.next = 88;
                  break;

                case 87:
                  (0, _commons.showToast)("Provide mobile no!", "error");

                case 88:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this4, [[40, 80], [55, 75]]);
        }));

        return function onClickPaymentOptionChoose(_x2, _x3) {
          return _ref3.apply(this, arguments);
        };
      }();

      return _react2.default.createElement(
        _Screen2.default,
        { xs: { p: 2 } },
        loadingStatus && _react2.default.createElement(_components.LoadingIndicator, null),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            _core.Card,
            { style: (0, _extends3.default)({}, _commons.styles.card, { margin: "21px 21px 19px" }), variant: "outlined" },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "div",
                { style: (0, _extends3.default)({}, _commons.styles.header, { width: "39rem" }) },
                "Unpaid Property Tax - All Unpaid Bills (PD, FS & LOI)"
              )
            ),
            _react2.default.createElement(
              _core.CardContent,
              null,
              _react2.default.createElement(
                _core.Grid,
                { container: true, spacing: 3 },
                _react2.default.createElement(
                  _core.Grid,
                  { item: true, xs: 3 },
                  _react2.default.createElement(_components.TextField, {
                    required: true,
                    type: "number",
                    name: "assesseeNo",
                    maxLength: 12,
                    id: "standard-required",
                    floatingLabelText: "Assessee No",
                    value: assesseeNo,
                    style: _commons.styles.textField,
                    onChange: function onChange(e) {
                      return _this4.setState({ assesseeNo: e.target.value.trim() });
                    },
                    onKeyDown: _validations.blockInvalidChar,
                    errorText: (0, _validations.validateAssesseeNumber)(assesseeNo)
                  })
                ),
                _react2.default.createElement(
                  _core.Grid,
                  { item: true, xs: 5 },
                  _react2.default.createElement(
                    _core.Grid,
                    { container: true, spacing: 3, direction: "row", style: { justifyContent: "center", margin: "18px 0" }, alignItems: "center" },
                    _react2.default.createElement(
                      _core.Grid,
                      { item: true, xs: 6, style: { textAlign: "end" } },
                      _react2.default.createElement(_components.MaterialButton, {
                        variant: "contained",
                        color: "primary",
                        style: (0, _extends3.default)({}, _commons.styles.searchButton, { width: "60%" }),
                        label: "Search",
                        onClick: this.onSearchHandler
                      })
                    ),
                    _react2.default.createElement(
                      _core.Grid,
                      { item: true, xs: 6 },
                      _react2.default.createElement(_components.MaterialButton, {
                        label: "Reset",
                        variant: "outlined",
                        color: "secondary",
                        style: (0, _extends3.default)({}, _commons.styles.resetButton, { width: "60%" }),
                        onClick: this.onResetHandler
                      })
                    )
                  )
                )
              )
            )
          )
        ),
        showTable && _react2.default.createElement(
          "div",
          { style: { marginTop: "23px" } },
          _react2.default.createElement(
            _core.Card,
            { style: _commons.styles.tableCard, variant: "outlined" },
            _react2.default.createElement(
              "div",
              { className: "d-flex flex-row", style: { margin: "23px" } },
              _react2.default.createElement(
                "div",
                { style: { margin: "0px 37px 0px 10px" } },
                _react2.default.createElement(
                  "span",
                  { style: { fontWeight: "bold" } },
                  "Ward: "
                ),
                " ",
                _react2.default.createElement(
                  "span",
                  null,
                  getValues("wardNo")
                )
              ),
              _react2.default.createElement(
                "div",
                { style: { margin: "0px 37px 0px 10px" } },
                _react2.default.createElement(
                  "span",
                  { style: { fontWeight: "bold" } },
                  "Premise No.: "
                ),
                " ",
                _react2.default.createElement(
                  "span",
                  null,
                  getValues("premisesNo")
                )
              ),
              _react2.default.createElement(
                "div",
                { style: { margin: "0px 37px 0px 10px" } },
                _react2.default.createElement(
                  "span",
                  { style: { fontWeight: "bold" } },
                  "Street Name: "
                ),
                " ",
                _react2.default.createElement(
                  "span",
                  null,
                  getValues("streetName")
                )
              )
            ),
            _react2.default.createElement(_components.DataTable, {
              columns: this.column,
              data: demandList,
              title: _react2.default.createElement(
                _core.Typography,
                { style: _commons.styles.tableHeader },
                "Demand List"
              ),
              options: options
            })
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            open: showModal,
            onClose: handleClose,
            "aria-labelledby": "form-dialog-title",
            style: { margin: "50px 0" },
            scroll: "paper",
            maxWidth: "xl"
          },
          _react2.default.createElement(
            _core.DialogTitle,
            { id: "form-dialog-title" },
            "Payment Option"
          ),
          _react2.default.createElement(
            _core.DialogContent,
            { style: { width: "74rem" } },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(_components.TextField, {
                type: "number",
                required: true,
                floatingLabelText: "Mobile No",
                maxLength: 10,
                onChange: function onChange(e) {
                  return _this4.setState({ mobileNo: e.target.value.trim() });
                },
                onKeyDown: _validations.blockInvalidChar,
                value: mobileNo,
                style: _commons.styles.textField
              })
            ),
            _react2.default.createElement(
              "div",
              { style: { fontWeight: "500", margin: "12px 0px" } },
              "Payment option"
            ),
            _react2.default.createElement(
              _core.Grid,
              { container: true, spacing: 3, className: "mt-2" },
              _react2.default.createElement(
                _core.Grid,
                { item: true, xs: 5 },
                _react2.default.createElement(_components.MaterialButton, {
                  label: "PayU",
                  style: (0, _extends3.default)({}, _commons.styles.searchButton, {
                    width: "84%",
                    background: "rgb(26 149 148 / 90%)",
                    border: "0px",
                    fontSize: "13px",
                    color: "white"
                  }),
                  onClick: function onClick(e) {
                    return onClickPaymentOptionChoose(e, "PAYU");
                  }
                })
              ),
              _react2.default.createElement(
                _core.Grid,
                { item: true, xs: 5 },
                _react2.default.createElement(_components.MaterialButton, {
                  label: "Billdesk",
                  style: (0, _extends3.default)({}, _commons.styles.searchButton, {
                    width: "84%",
                    border: "0px",
                    fontSize: "13px",
                    background: "rgb(181 178 22 / 90%)",
                    color: "white"
                  }),
                  onClick: function onClick(e) {
                    return onClickPaymentOptionChoose(e, "BILLDESK");
                  }
                })
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "text-end mt-5" },
              _react2.default.createElement(_components.MaterialButton, {
                label: "Close",
                variant: "outlined",
                color: "secondary",
                style: (0, _extends3.default)({}, _commons.styles.resetButton, { width: "33%", height: "0px" }),
                onClick: handleClose
              })
            )
          )
        )
      );
    }
  }]);
  return CurrentDemand;
}(_react.Component);

exports.default = CurrentDemand;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/OnlinePayment/index.js
// module id = 3314
// module chunks = 1137